import fixDateTimezone from './fixDateTimezone';

// ÐÐ¾Ð»Ð¾Ð½ÐºÐ° signedAt â timestamp Ð±ÐµÐ· Ð·Ð¾Ð½Ñ: Ð±ÑÐº Ð¾ÑÐ´Ð°ÑÑ UTC Ð±ÐµÐ· Â«ZÂ», Ð¸ dayjs ÑÐ¸ÑÐ°Ð» Ð±Ñ ÐµÐ³Ð¾ ÐºÐ°Ðº Ð»Ð¾ÐºÐ°Ð»ÑÐ½Ð¾Ðµ Ð²ÑÐµÐ¼Ñ.
// ÐÐ¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼ Ð²ÑÐµÐ³Ð´Ð° Ð¿Ð¾ ÐÐ°Ð·Ð°ÑÑÑÐ°Ð½Ñ (UTC+5), ÐºÐ°Ðº Ð² PDF ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ñ, â Ð½ÐµÐ·Ð°Ð²Ð¸ÑÐ¸Ð¼Ð¾ Ð¾Ñ Ð¿Ð¾ÑÑÐ° Ð·ÑÐ¸ÑÐµÐ»Ñ.
const asUtc = (value) => (/(Z|[+-]\d\d:?\d\d)$/.test(value) ? value : `${value}Z`);

const formatSignedAt = (value) => (value ? fixDateTimezone(asUtc(value)).format('DD.MM.YYYY HH:mm:ss') : 'â');

export default formatSignedAt;
